import React, {Component} from 'react';

import {AgencyFlexIndicatorsConfigurationContent} from "./AgencyFlexIndicatorsConfigurationContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencyFlexIndicatorsConfiguration extends Component {

    getOnBoardingStatus() {
        if (this.props.location.state === undefined || this.props.location.state === null) {
            return false
        } else {
            return this.props.location.state.showOnBoarding
        }
    }

    render() {
        return (
            <AgencyFlexIndicatorsConfigurationContent agencyId={this.props.match.params.id} />
        )
    }
}

export default withRouterParams(AgencyFlexIndicatorsConfiguration);

